import { LoginModel } from "./../components";
import { login } from "./../API/dispatch";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Spin } from "antd";

import "./style/gitkey.css";
export function Login({ setAuth }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (event) => {
    setLoading(true);
    const data = await login("/auth/login", event, setLoading);
    if (data?.success) {
      setAuth(true);
      navigate("/ai/users");
      setLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={loading}>
        <div class="square1">A</div>
        <div class="square2">I</div>
        <div class="letter">StockBot (Options)</div>
      </Spin>
      <LoginModel onFininsh={handleFinish} />
    </>
  );
}

export default Login;
